export const SendDisabled = ( 
    <svg viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.25" filter="url(#filter0_d_1081_29558)">
        <path d="M64 41C64 55.9117 51.9117 68 37 68C22.0883 68 10 55.9117 10 41C10 26.0883 22.0883 14 37 14C51.9117 14 64 26.0883 64 41Z" fill="var(--YW_Body_Inactive_Submit_Button_Color)"/>
        </g>
        <path d="M29.01 50L50 41L29.01 32L29 39L44 41L29 43L29.01 50Z" fill="white"/>
        <defs>
        <filter id="filter0_d_1081_29558" x="0" y="0" width="74" height="74" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="-4"/>
        <feGaussianBlur stdDeviation="5"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1081_29558"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1081_29558" result="shape"/>
        </filter>
        </defs>
    </svg>
)
